// PrivacyPolicy.js
import React from "react";
import "./PrivacyPolicy.css"; // Create and style as needed

function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p>Last updated: January 4, 2025</p>

      <section>
        <h2>1. Introduction</h2>
        <p>
          Welcome to Avro! Your privacy is critically important to us. This
          Privacy Policy explains how we collect, use, and protect your
          information when you use our mobile application ("App").
        </p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <p>
          We collect information that you provide directly to us, such as when
          you create an account, update your profile, or use the App's features.
        </p>
        <ul>
          <li>
            <strong>Personal Information:</strong> Name, email address, and
            other contact details.
          </li>
          <li>
            <strong>Usage Data:</strong> Information about how you use the App,
            including feature usage and interaction data.
          </li>
          <li>
            <strong>Device Information:</strong> Device type, operating system,
            and other technical details.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide, operate, and maintain the App</li>
          <li>Improve, personalize, and expand the App</li>
          <li>Understand and analyze how you use the App</li>
          <li>Develop new products, services, features, and functionality</li>
          <li>
            Communicate with you, either directly or through one of our partners
          </li>
          <li>Send you updates, newsletters, and marketing materials</li>
          <li>Provide customer support</li>
        </ul>
      </section>

      <section>
        <h2>4. Sharing Your Information</h2>
        <p>
          We do not sell, trade, or otherwise transfer your personal information
          to outside parties except as described in this Privacy Policy.
        </p>
      </section>

      <section>
        <h2>5. Data Security</h2>
        <p>
          We implement a variety of security measures to maintain the safety of
          your personal information. However, no method of transmission over the
          internet or electronic storage is 100% secure.
        </p>
      </section>

      <section>
        <h2>6. Your Rights</h2>
        <p>
          You have the right to access, update, or delete your personal
          information. You can do this by logging into your account and updating
          your profile settings.
        </p>
      </section>

      <section>
        <h2>7. Changes to This Privacy Policy</h2>
        <p>
          We may update our Privacy Policy from time to time. We will notify you
          of any changes by posting the new Privacy Policy on this page.
        </p>
      </section>

      <section>
        <h2>8. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us
          at <a href="mailto:support@avroapp.com">support@avroapp.com</a>.
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
